<template>
    <b-container fluid> 
        <app-sub-title :text="'Asignación de personal para la ' + theDoor.name" />
        <b-row class="mt-4">
            <b-col>
                <app-door-assignment-filters ref="doorAssignmentFilter" @filter="onFilter"/>
            </b-col>
        </b-row>
        <b-row class="mt-3" align-h="end">
            <b-col
                cols="12"
                md="4"
                lg="3"
                class="d-flex justify-content-end"
            >
                <a href="#" @click.prevent="selectAll">Todos</a>
                &nbsp;|&nbsp;
                <a href="#" @click.prevent="selectNone">Ninguno</a>
            </b-col>
        </b-row>
        <app-data-table class="mt-3"
            :fields="fields"
            :items="data.data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="actions" slot-scope="{ item }">
                <b-row>
                    <b-col lg="2">
                        <b-form-checkbox
                            :value="item.id"
                            v-model="peopleSelected"
                            switch
                        >
                            Seleccione</b-form-checkbox
                        >
                    </b-col>
                </b-row>
            </template>
        </app-data-table>
    </b-container>
</template>
<script>
import appDoorAssignmentFilters from './DoorAssignmentFilters'
export default {
    props:{
        theDoor: {
            type:[Array, Object],
            default: {}
        }
    },
    components: {
        appDoorAssignmentFilters,
    },
    data: () =>({
        data: [],
        page: 1,
        peopleSelected: [],
        fields,
        sortBy: 'created_at',
        sortDir: 'desc',
        filters: null
    }),
    methods: {
        onFilter(filters){
            this.filters = filters
            this.data = []
            this.loadInternalPeople()
        },
        async loadInternalPeople(){
            const params = {
                    ...this.filters,
                    page: this.page,
                    clientId: this.client.id
            }
            const {data} = await repo.get('people/internals', params)
            this.data = data
        },
        selectAll() {
            this.data.data.map(item => this.peopleSelected.push(item.id))
        },
        selectNone() {
            this.peopleSelected = []
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadInternalPeople()
        },
        onChangePage(page) {
            this.page = page
            this.loadInternalPeople()
        },
        async assignPeople(){
            if(this.peopleSelected.length == 0){
                return toastr.info('Porfavor seleccione almenos a una persona')
            }
            const {data} = await repo.post(`doors/${this.theDoor.id}/assign-people`, {
                peopleSelected: this.peopleSelected
                })
            if(data.status){
                this.$emit('assigned-people', data)
                this.selectNone()
            }else{
                return toastr.error('Ocurrio un error al asignar al personal')
            }
        },
        async loadPeopleAssigned(door){
            this.peopleSelected = []
            this.$refs.doorAssignmentFilter.clear()
            const {data} = await repo.get(`doors/${door.id}/assigned-people`)
            data.map((item) => this.peopleSelected.push(item.id))
        }
    },
    mounted(){
        this.loadInternalPeople()
    }
}
const fields = [
    {
        key: 'name',
        label: 'Persona',
    },
    {
        key: 'document',
        label: 'Documento',
    },
    {
        key: 'position',
        label: 'Cargo',
    },
    {
        key: 'email',
        label: 'Correo',
    },
    {
        key: 'venue_name',
        label: 'Sede',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>